import Option from '@/modules/common/models/option/option.ts';

export class LinkTypeOption extends Option<number> {
  tableIds: number[];

  constructor(response: any) {
    super(response, 'LT_ID', 'Название');
    this.tableIds = response['Доступен'];
  }
}
